<template>
  <div>
    <div ref="container" class="verlet-container"></div>

    <div class="controls">
      <label>Время записи (сек):</label>
      <input type="number" v-model.number="recordTime" min="1" max="60" />

      <button @click="resetGraph">Очистить график</button>
      <button @click="saveGraph">Сохранить график снизу</button>
    </div>

    <div class="ct-chart" ref="chart"></div>
  </div>
</template>

<script>
import p5 from 'p5';
import * as toxi from "toxiclibsjs";
import * as Chartist from "chartist";
import "chartist/dist/chartist.min.css";

export default {
  name: "VerletRope",
  data() {
    return {
      recordTime: 10,       // время записи, секунд
      recording: false,     // идёт ли запись
      startTime: 0,         // момент начала записи
      dataPoints: [],       // массив данных для графика
      chart: null,          // объект графика
      mass: 0.2             // масса последней точки (кг)
    };
  },
  methods: {
    updateChart() {
  if (this.dataPoints.length === 0) return;

  const step = 30; // каждые 30 кадров ≈ 0.5 сек при 60 FPS

  // формируем подписи только на каждые 0.5 сек
  const labels = [];
  for (let i = 0; i < this.dataPoints.length; i++) {
    if (i % step === 0) {
      labels.push((i / 60).toFixed(1)); // время в секундах
    } else {
      labels.push(null); // пустая подпись
    }
  }

const series = [this.dataPoints.map(a => a * this.mass)];


  const options = {
    showPoint: false,
    axisX: {
      showGrid: false,
      labelInterpolationFnc: (value) => (value ? value + ' c' : null),
    },
    axisY: { onlyInteger: false },
    height: '200px',
    low: 0, // минимальное значение по оси Y
    high: Math.max(...series[0]) * 1.1, // немного больше максимума для отступа сверху
  };

  // создание или обновление графика
  if (!this.chart) {
    this.chart = new Chartist.Line(this.$refs.chart, { labels, series }, options);
  } else {
    this.chart.update({ labels, series }, options);
  }
    },
    resetGraph() {
      this.dataPoints = [];
      if (this.chart) {
        this.chart.update({ labels: [], series: [[]] });
      }
    },
    
    saveGraph() {
      if (this.dataPoints.length === 0) return;
      const chartContainer = document.createElement('div');
      chartContainer.className = 'ct-chart2';
      chartContainer.style.marginTop = '20px';
      chartContainer.style.background = '#fff';
      this.$refs.chart.parentNode.appendChild(chartContainer);
      const deleteBtn = document.createElement('button');
      deleteBtn.textContent = 'Удалить график';



      deleteBtn.onclick = () => {
        chartContainer.parentNode.removeChild(chartContainer);
        deleteBtn.parentNode && deleteBtn.parentNode.removeChild(deleteBtn);
      };

      chartContainer.parentNode.insertBefore(deleteBtn, chartContainer.nextSibling, );

      const step = 30;
      const labels = [];
      for (let i = 0; i < this.dataPoints.length; i++) {
        if (i % step === 0) {
          labels.push((i / 60).toFixed(1));
        } else {
          labels.push(null);
        }
      }
      const series = [this.dataPoints.map(a => a * this.mass)];

      const options = {
        showPoint: false,
        axisX: {
          showGrid: false,
          labelInterpolationFnc: (value) => (value ? value + ' c' : null),
        },
        axisY: { onlyInteger: false },
        height: '200px',
        low: 0,
        high: Math.max(...series[0]) * 1.1,
      };

      new Chartist.Line(chartContainer, { labels, series }, options);
},

  },
  mounted() {
    new p5((sketch) => {
      let { Vec2D, Rect } = toxi.geom;
      let { VerletPhysics2D, VerletParticle2D, VerletSpring2D } = toxi.physics2d;
      let { GravityBehavior } = toxi.physics2d.behaviors;

      let physics;
      let particles = [];

      sketch.setup = () => {
        let canvas = sketch.createCanvas(640, 240);
        canvas.parent(this.$refs.container);

        // физика
        physics = new VerletPhysics2D();
        physics.setWorldBounds(new Rect(0, 0, sketch.width, sketch.height));
        physics.addBehavior(new GravityBehavior(new Vec2D(0, 0.5)));

        let spacing = 10;
        let total = 20;

        for (let i = 0; i < total; i++) {
          let particle = new Particle(sketch.width / 2 + i * spacing, 0, 8);
          physics.addParticle(particle);
          particles.push(particle);
        }

        // пружины
        for (let i = 0; i < total - 1; i++) {
          let spring = new VerletSpring2D(particles[i], particles[i + 1], spacing, 0.2);
          physics.addSpring(spring);
        }

        particles[0].lock(); // первая частица фиксирована
      };

      sketch.draw = () => {
        physics.update();
        sketch.background(255);

        // рисуем "верёвку"
        sketch.stroke(0);
        sketch.noFill();
        sketch.beginShape();
        for (let p of particles) sketch.vertex(p.x, p.y);
        sketch.endShape();

        particles[particles.length - 1].show(sketch);

        // перемещение последней точки мышью
        // если мышь на конвасе
  

        if (sketch.mouseIsPressed &&
            sketch.mouseX >= 0 && sketch.mouseX <= sketch.width &&
            sketch.mouseY >= 0 && sketch.mouseY <= sketch.height) {
          let end = particles[particles.length - 1];
          end.lock();
          end.x = sketch.mouseX;
          end.y = sketch.mouseY;
          end.unlock();

          this.recording = false; // пока тянем — запись не идёт
        } else {
          // если отпустили мышь — начать запись
          if (!this.recording) {
            this.recording = true;
            this.dataPoints = [];
            this.startTime = sketch.millis();
          } else {
            let t = (sketch.millis() - this.startTime) / 1000;
            if (t <= this.recordTime) {
              let end = particles[particles.length - 1];
              this.dataPoints.push(end.y);
              this.updateChart();
            }
          }
        }
      };

      // Класс частицы
      class Particle extends VerletParticle2D {
        constructor(x, y, r) {
          super(x, y);
          this.r = r;
        }

        show(s) {
          s.fill(127);
          s.stroke(0);
          s.circle(this.x, this.y, this.r * 2);
        }
      }
    });
  },
};
</script>

<style scoped>
.verlet-container {
  width: 640px;
  height: 260px;
  border: 1px solid #ccc;
  
  padding: 10px;
}

.controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

input {
  width: 60px;
}

.ct-chart {
  width: 1240px;
  height: 200px;
}

</style>
